import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <span className="text-2xl font-black tracking-tight">EduLabs</span>
            <p className="text-background/50 text-sm mt-3 leading-relaxed max-w-xs">
              Your one-stop platform for creating classrooms, managing students, and conducting exams.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4 text-background/70">Platform</h4>
            <ul className="space-y-3 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/premium", label: "Premium" },
                { to: "/auth", label: "Sign In" },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-background/50 hover:text-background transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4 text-background/70">Legal</h4>
            <ul className="space-y-3 text-sm">
              {[
                { to: "/terms-and-conditions", label: "Terms & Conditions" },
                { to: "/privacy-policy", label: "Privacy Policy" },
                { to: "/refund-policy", label: "Refund Policy" },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-background/50 hover:text-background transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4 text-background/70">Support</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/support" className="text-background/50 hover:text-background transition-colors">
                  Help Center
                </Link>
              </li>
              <li>
                <span className="text-background/50">admin@conceptlabs.online</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background/10 pt-6 text-center text-background/30 text-xs">
          <p>© {new Date().getFullYear()} EduLabs By ConceptLabs Academy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
